var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideoPause = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "M30 59c16.016 0 29-12.984 29-29S46.016 1 30 1 1 13.984 1 30s12.984 29 29 29Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 18,
  x: 23,
  y: 21,
  fill: "#fff",
  rx: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 18,
  x: 32,
  y: 21,
  fill: "#fff",
  rx: 1
})));
export { SvgVideoPause as ReactComponent };
export default "/_next/static/images/videoPause.svg";